import { render, staticRenderFns } from "./ListExceptionsOV.vue?vue&type=template&id=74c1c2c0&scoped=true&lang=pug"
import script from "./ListExceptionsOV.vue?vue&type=script&lang=js"
export * from "./ListExceptionsOV.vue?vue&type=script&lang=js"
import style0 from "./ListExceptionsOV.vue?vue&type=style&index=0&id=74c1c2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1c2c0",
  null
  
)

export default component.exports